











































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Message } from '@/business/message/models/message'
import RespondecoBackgroundImage from '@/shared/components/respondeco-background-image.vue'

@Component({
  components: { RespondecoBackgroundImage },
})
export default class OutgoingMessage extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  public readonly message!: Message
}
